import Vue from 'vue/dist/vue.esm';
// 套件
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Datepicker from 'vuejs-datepicker';
// store
import store from './store';
// 其他元件
import RoomAsideForm from './components/room_aside_form.vue';
import TimeRange from './components/time_range.vue';
import HomeForm from './components/home_form.vue';
import NewOrder from './components/new_order.vue';
import BookingForm from './components/booking_form.vue';

// vue init
document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    el: '#vue-app',
    store
  })
});

// 套件使用
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('Datepicker', Datepicker);

// 元件套用
Vue.component('room-aside-form', RoomAsideForm);
Vue.component('time-range', TimeRange);
Vue.component('home-form', HomeForm);
Vue.component('new-order', NewOrder);
Vue.component('booking-form', BookingForm);